import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { IListaAnhos, IReqBodyCrearPonderacion, IResCrearPonderacion, IResValidarNotas, IResValidarPonderacion } from 'src/app/interfaces/ponderaciones';
import { NgxSpinnerService } from 'ngx-spinner';
import { PonderacionesService } from 'src/app/services/ponderaciones/ponderaciones.service';
import { FormBuilder } from '@angular/forms';
import { ICalificacion, IExamen } from 'src/app/interfaces/ponderaciones';
import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-view-ponderacion-individual-crear',
  templateUrl: './view-ponderacion-individual-crear.component.html',
  styleUrls: ['./view-ponderacion-individual-crear.component.scss']
})
export class ViewPonderacionIndividualCrearComponent {
  calificacionesParciales: Array<ICalificacion> = []
  calificacionesExamenes: Array<IExamen> = []
  activarExamenExtraordinario: boolean = false;

  ponderacionPCP: number = 60
  ponderacionPCET: number = 40

  minParciales: number = 1
  maxParciales: number = 20
  minParcialesSetting = 3

  minExamenes: number = 0
  maxExamenes: number = 2
  minExamenesSetting: number = 1

  examenExtraordinario: number = 0;

  cantidadCajasParciales: number = 0
  cantidadCajasExamenes: number = 0

  infoModalTitulo: string = ''
  infoModalTexto: string = ''

  filtroAnhos: Array<number> = []
  filtroAnhoSeleccionado: number | null = null
  filtroPeriodos: Array<any> = []
  filtroPeriodoSeleccionado: number | null = null
  filtroSedes: Array<any> = []
  filtroSedeSeleccionado: number = -1
  filtroAsignaturas: Array<any> = []
  filtroAsignaturaSeleccionado: number | null = null
  filtroSecciones: Array<any> = []
  filtroSeccionSeleccionado: number | null = null

  deshabilitarCrear: boolean = false
  configData: any = null

  reqDisponibles: number = 0

  textoError: string = ''
  textoValidarPonderacion: string = 'Existe configuraciones previas para los criterios seleccionados. <br> ¿Está seguro que desea reemplazarlas?'


  constructor(
    private formBuilder: FormBuilder,
    private _ponderaciones: PonderacionesService,
    private spinner: NgxSpinnerService,
    private _perfilamiento: PerfilamientoService,
    private router: Router
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if (routerData?.configuracion) {
      this.configData = routerData.configuracion
      // this.reqDisponibles = Object.keys(this.configData).length
      Object.keys(this.configData).forEach(
        (key: any, i) => {
          if (this.configData[key] !== 0) {
            this.reqDisponibles++
          }
        }
      )
    } else {
      this.router.navigateByUrl('/ponderacion-individual-inicio')
      return
    }
    this.getAnhos()
  }

  volverInicio(): void {
    let configuracion = this.configData;
    this.router.navigate(['/ponderacion-individual-inicio'], { state: { data: { configuracion: configuracion } } })
  }

  ngOnInit() {
    this._ponderaciones.getConfiguracionBase(this.configData.anyo, this.configData.periodoId, this.configData.asignaturaId).subscribe({
      next: (res: any) => {
        this.minParciales = res.notasParciales.length;
        res.notasParciales.forEach((nota: any) => {
          
          const porcentajePorDefecto = {porcentaje: nota.porcentaje};
          this.calificacionesParciales = [...this.calificacionesParciales, porcentajePorDefecto];
          this.cantidadCajasParciales = this.calificacionesParciales.length
        });
        this.minExamenes = res.examenes.length;
        res.examenes.forEach((nota: any) => {
          const porcentajeEx = {porcentajeE: nota.porcentaje};
          this.calificacionesExamenes = [...this.calificacionesExamenes, porcentajeEx];
          this.cantidadCajasExamenes = this.calificacionesExamenes.length;
        })
      }
    })
  }

  getAnhos() {
    this._ponderaciones.getFiltrosAnhos().subscribe(
      (res: IListaAnhos) => {
        this.filtroAnhos = res.anyos
        if (this.configData?.anyo && this.reqDisponibles > 0) {
          this.reqDisponibles--
          this.filtroAnhoSeleccionado = this.configData.anyo
          this.seleccionFiltro('anho')
        }
      }
    )
  }

  getSedesAsignatura() {
    if (this.filtroAnhoSeleccionado !== null && this.filtroPeriodoSeleccionado !== null && this.filtroAsignaturaSeleccionado !== null) {
      this._ponderaciones.getFiltrosSedesSigla(this._perfilamiento.getUsuario()?.usuarioId,
        Number(this.filtroAnhoSeleccionado),
        Number(this.filtroPeriodoSeleccionado),
        Number(this.filtroAsignaturaSeleccionado)
      ).subscribe(
        (res: any) => {
          this.filtroSedes = res.sedes
          if (this.configData?.sedeId) {
            this.reqDisponibles--
            this.filtroSedeSeleccionado = this.configData.sedeId
            this.seleccionFiltro('sede')
          }
          if (this.configData?.sedeId === 0) {
            this.getSecciones();
          }
        }, err => {
        }
      )
    }
  }

  getSedes() {
    this._ponderaciones.getFiltrosSedes(this._perfilamiento.getUsuario()?.usuarioId,
    ).subscribe(
      (res: any) => {
        this.filtroSedes = res.sedes
        if (this.configData?.sedeId && this.reqDisponibles > 0) {
          this.reqDisponibles--
          this.filtroSedeSeleccionado = this.configData.sedeId
          this.seleccionFiltro('sede')
        }
        if (this.reqDisponibles === 0) {
          // this.getEscuelas()
        }
      }, err => {
      }
    )
  }

  getPeriodos() {
    this._ponderaciones.getFiltrosPeriodos(Number(this.filtroAnhoSeleccionado)).subscribe(
      (res: any) => {
        this.filtroPeriodos = res.periodos
        if (this.configData?.periodoId && this.reqDisponibles > 0) {
          this.reqDisponibles--
          this.filtroPeriodoSeleccionado = this.configData.periodoId
          this.seleccionFiltro('periodo')
        }
      }
    )
  }

  getAsignaturas() {
    let sedeId = this.filtroSedeSeleccionado !== null ? Number(this.filtroSedeSeleccionado) : 0
    this._ponderaciones.getFiltrosAsignaturas({
      anyo: Number(this.filtroAnhoSeleccionado),
      periodoId: Number(this.filtroPeriodoSeleccionado),
      sedeId: sedeId
    }).subscribe(
      (res: any) => {
        this.filtroAsignaturas = res.asignaturas
        if (this.configData?.asignaturaId && this.reqDisponibles > 0) {
          this.reqDisponibles--
          this.filtroAsignaturaSeleccionado = this.configData.asignaturaId
          this.seleccionFiltro('asignatura')
        }
      }
    )
  }


  getSecciones() {
    this._ponderaciones.getFiltrosSecciones({
      anyo: Number(this.filtroAnhoSeleccionado),
      periodoId: Number(this.filtroPeriodoSeleccionado),
      sedeId: this.filtroSedeSeleccionado != -1 ? Number(this.filtroSedeSeleccionado) : 0,
      asignaturaId: Number(this.filtroAsignaturaSeleccionado)
    }).subscribe(
      (res: any) => {
        this.filtroSecciones = res.secciones
        if (this.configData?.seccionId && this.reqDisponibles > 0) {
          this.reqDisponibles--
          this.filtroSeccionSeleccionado = this.configData.seccionId
        }
      }
    )
  }

  seleccionFiltro(filtro: string = '') {
    switch (filtro) {
      case 'anho':
        this.getPeriodos()
        this.filtroPeriodoSeleccionado = null
        this.filtroAsignaturaSeleccionado = null
        this.filtroSeccionSeleccionado = null
        this.filtroSedeSeleccionado = -1
        break;
      case 'periodo':
        this.getAsignaturas()
        this.filtroAsignaturaSeleccionado = null
        this.filtroSeccionSeleccionado = null
        this.filtroSedeSeleccionado = -1
        break;
      case 'asignatura':
        this.getSedesAsignatura()
        this.filtroSeccionSeleccionado = null
        this.filtroSedeSeleccionado = -1
        break;
      case 'sede':
        this.getSecciones()
        this.filtroSeccionSeleccionado = null
        this.filtroSecciones = [];

        break;
      default:
        break;
    }
  }

  agregarCalif(tipo: string) {
    switch (tipo) {
      case 'calificacionesParciales':
        this.calificacionesParciales = [...this.calificacionesParciales, { porcentaje: 0 }]
        break;
      case 'calificacionesExamenes':
        this.calificacionesExamenes = [...this.calificacionesExamenes, { porcentajeE: 100 }]
        break;
      default:
        break;
    }
  }

  quitarCalif(tipo: string) {
    switch (tipo) {
      case 'calificacionesParciales':
        this.calificacionesParciales.pop()
        break;
      case 'calificacionesExamenes':
        this.calificacionesExamenes.pop()
        if (this.calificacionesExamenes.length === 0) {
          this.ponderacionPCET = 0
          this.ponderacionPCP = 100
        }
        break;
      default:
        break;
    }
  }

  totalParciales() {
    let porcentaje: number = 0
    this.calificacionesParciales.forEach((calificacion: ICalificacion) => {
      porcentaje += calificacion.porcentaje
    })
    return porcentaje
  }

  totalExamenes() {
    let porcentajeEx: number = 0
    this.calificacionesExamenes.forEach((calificacion: IExamen) => {
      porcentajeEx += calificacion.porcentajeE
    })
    return porcentajeEx
  }

  switchExamenExtraordinario() {
    this.activarExamenExtraordinario = !this.activarExamenExtraordinario;
  }

  totalPonderacionPromedio() {
    let total: number = 0
    if (this.calificacionesExamenes.length > 0) {
      total = this.ponderacionPCET + this.ponderacionPCP
    } else {
      total = this.ponderacionPCP
    }
    return total;
  }

  ingresoCajasPonderaciones(tipo: string) {
    switch (tipo) {
      case 'calificacionesParciales':
        if (this.cantidadCajasParciales >= this.maxParciales) {
          this.cantidadCajasParciales = this.maxParciales
        }
        this.calificacionesParciales = [];
        for (let index = 0; index < this.cantidadCajasParciales; index++) {
          this.calificacionesParciales = [...this.calificacionesParciales, { porcentaje: 0 }]
        }
        break;
      case 'calificacionesExamenes':
        if (this.cantidadCajasExamenes >= this.maxExamenes) {
          this.cantidadCajasExamenes = this.maxExamenes
        }
        this.calificacionesExamenes = [];
        for (let index = 0; index < this.cantidadCajasExamenes; index++) {
          this.calificacionesExamenes = [...this.calificacionesExamenes, { porcentajeE: 0 }]
        }
        break;
      default:
        break;
    }
  }

  btnCrearHabilitado() {
    if (this.deshabilitarCrear) {
      return false
    }
    if (this.filtroAnhoSeleccionado === null || this.filtroPeriodoSeleccionado === null || this.filtroAsignaturaSeleccionado === null) {
      return false
    }
    return true
  }

  modalFaltaPonderacion() {
    this.infoModalTitulo = 'Aviso'
    this.infoModalTexto = 'Debes completar todas las ponderaciones de las calificaciones agregadas <br> <span>Las ponderaciones no deben ser 0</span>'
    document.getElementById('btn-modal-info')?.click()
  }

  limpiarTextoError() {
    document.getElementById('idBreadcrumb')?.scrollIntoView()
    setTimeout(() => {
      this.textoError = ''
    }, 3000);
  }

  modalAvisoTotalCalificaciones(texto: string = 'El total de las ponderaciones de las calificaciones parciales debe ser 100%') {
    this.textoError = texto
    this.limpiarTextoError()
  }

  modalPonderacionCreada() {
    this.infoModalTitulo = 'Exito'
    this.infoModalTexto = 'La ponderación ha sido creada exitosamente. Serás redireccionado...'
    document.getElementById('btn-modal-info')?.click()
  }

  modalValidacionPcet() {
    this.textoError = 'El Promedio examen (PCET) no puede ser 0 cuando existe 1 o más exámenes'
    this.limpiarTextoError()
  }

  modalPonderacionPromedios() {
    this.textoError = 'La Ponderación Promedios debe ser 100. El % Promedio examen (PCET) puede ser 0 cuando la cantidad de exámenes es 0'
    this.limpiarTextoError()
  }

  validarPonderaciones() {
    const parcialesEnCero = this.calificacionesParciales.filter((parcial: any) => parcial.porcentaje === 0)
    const examenesEnCero = this.calificacionesExamenes.filter((examen: any) => examen.porcentajeE === 0)
    let promedioCalificacionesParciales: number = 0
    let promedioCalificacionesExamenes: number = 0
    this.calificacionesParciales.forEach((parcial: any) => {
      promedioCalificacionesParciales += parcial.porcentaje
    })
    this.calificacionesExamenes.forEach((examen: any) => {
      promedioCalificacionesExamenes += examen.porcentajeE
    })
    if (parcialesEnCero.length > 0 || examenesEnCero.length > 0) {
      this.modalFaltaPonderacion()
      return false
    }
    if (this.calificacionesExamenes.length > 0 && this.ponderacionPCET === 0) {
      this.modalValidacionPcet()
      return false
    }
    if (promedioCalificacionesParciales !== 100) {
      this.modalAvisoTotalCalificaciones('El total de las ponderaciones de las calificaciones parciales debe ser 100%')
      return false
    }
    if (this.calificacionesExamenes.length > 0 && promedioCalificacionesExamenes !== 100) {
      this.modalAvisoTotalCalificaciones('El total de las ponderaciones del examen debe ser 100%')
      return false
    }
    if (this.calificacionesExamenes.length > 0 && promedioCalificacionesExamenes !== 100) {
      this.modalAvisoTotalCalificaciones('El total de las ponderaciones del examen debe ser 100%')
      return false
    }
    if (this.calificacionesExamenes.length > 0 && (this.ponderacionPCET + this.ponderacionPCP !== 100)) {
      this.modalPonderacionPromedios()
      return false
    }
    if ((this.calificacionesExamenes.length === 0 && this.ponderacionPCP !== 100) || this.ponderacionPCP === 0) {
      this.modalPonderacionPromedios()
      return false
    }
    return true
  }

  validarNotasIngresadas(): void {
    if (!this.validarPonderaciones()) {
      return
    }
    this._ponderaciones.validarNotas(
      this.filtroAnhoSeleccionado ? Number(this.filtroAnhoSeleccionado) : 0,
      this.filtroPeriodoSeleccionado ? Number(this.filtroPeriodoSeleccionado) : 0,
      this.filtroSedeSeleccionado != -1 ? Number(this.filtroSedeSeleccionado) : 0,
      this.filtroSeccionSeleccionado ? Number(this.filtroSeccionSeleccionado) : 0
    ).subscribe(
      (res: IResValidarNotas) => {
        if ( res.error === null ) {
          if ( !res.valor ) {
            this.validarPonderacion()
          } else {
            document.getElementById('modal-notas-ingresadas-btn')?.click()
          }
        } else {
          this.infoModalTitulo = 'Aviso'
          this.infoModalTexto = res?.error?.mensaje ?? 'Hubo un error en los servicios.'
          document.getElementById('btn-modal-info')?.click()
        }
      }
    )
  }

  validarPonderacion() {
    this._ponderaciones.validarPonderacionIndividual({
      anyo: this.filtroAnhoSeleccionado ? Number(this.filtroAnhoSeleccionado) : null,
      periodoId: this.filtroPeriodoSeleccionado ? Number(this.filtroPeriodoSeleccionado) : null,
      asignaturaId: this.filtroAsignaturaSeleccionado ? Number(this.filtroAsignaturaSeleccionado) : null,
      sedeId: this.filtroSedeSeleccionado != -1 ? Number(this.filtroSedeSeleccionado) : null,
      seccionId: this.filtroSeccionSeleccionado ? Number(this.filtroSeccionSeleccionado) : null
    }).subscribe(
      (res: IResValidarPonderacion) => {
        if (res.codigo === 200) {
          if (res?.error?.mensaje) {
            this.textoValidarPonderacion = res.error.mensaje + '<br> ¿Está seguro que desea reemplazarlas?'
          }
          document.getElementById('btn-modal-confirmar')?.click()
        }
        else if (res.codigo === 404) {
          this.crearPonderacionIndividual()
        }
        else if (res.codigo !== 200 ) {
          this.infoModalTitulo = 'Atención'
          this.infoModalTexto = res?.error?.mensaje ? res.error.mensaje : 'Hubo un error en los servicios.'
          document.getElementById('btn-modal-info')?.click()
        }
      }, (err: any) => {
        this.infoModalTitulo = 'Error'
        this.infoModalTexto = 'Error en los servicios.'
        // document.getElementById('btn-modal-info')?.click()
      }
    )
  }

  crearPonderacionIndividual() {
    let notasParciales: Array<number> = []
    this.calificacionesParciales.forEach(element => {
      notasParciales.push(element.porcentaje)
    });
    let notasExamenes: Array<number> = []
    this.calificacionesExamenes.forEach(element => {
      notasExamenes.push(element.porcentajeE)
    });
    const body: IReqBodyCrearPonderacion = {
      configuracion: {
        anyo: this.filtroAnhoSeleccionado ? Number(this.filtroAnhoSeleccionado) : null,
        periodoId: this.filtroPeriodoSeleccionado ? Number(this.filtroPeriodoSeleccionado) : null,
        asignaturaId: this.filtroAsignaturaSeleccionado ? Number(this.filtroAsignaturaSeleccionado) : null,
        sedeId: this.filtroSedeSeleccionado != -1 ? Number(this.filtroSedeSeleccionado) : null,
        seccionId: this.filtroSeccionSeleccionado ? Number(this.filtroSeccionSeleccionado) : null
      },
      cantidadNotas: this.calificacionesParciales.length,
      promedioNotas: notasParciales,
      cantidadExamenes: this.calificacionesExamenes.length,
      promedioExamenes: notasExamenes,
      examenExtraordinario: this.activarExamenExtraordinario,
      promedioExamenesExtraordinario: this.activarExamenExtraordinario ? notasExamenes : [],
      ponderacionPCP: this.ponderacionPCP,
      ponderacionPCET: this.ponderacionPCET
    }
    this._ponderaciones.crearPonderacionIndividual(body).subscribe(
      (res: IResCrearPonderacion) => {
        if (res.error === null) {
          this.deshabilitarCrear = true
          let configuracion = this.configData;
          this.router.navigate(['/ponderacion-individual-inicio'], { state: { data: { ponderacionCreada: true, configuracion: configuracion } } })
        } else {
          this.infoModalTitulo = 'Aviso'
          this.infoModalTexto = res.error?.mensaje ? res.error.mensaje : 'Hubo un error en los servicios.'
          document.getElementById('btn-modal-info')?.click()
        }
      }, (err: any) => {
      }
    )
  }

  crear() {
    // this.popFaltaPonderacion()
    if (!this.validarPonderaciones()) {
      return
    }

    this.validarPonderacion()

  }
}
